module.exports = {"name":"axui-datagrid","version":"0.15.2","description":"DataGrid, DataSheet for React","jsnext:main":"es6/index.js","module":"es6/index.js","main":"commonjs/index.js","repository":"https://github.com/jsdevkr/axui-datagrid","website":"http://axui-datagrid.jsdev.kr","author":"tom@axisj.com","license":"MIT","keywords":["datagrid, react-datagrid, react-component, typescript"]}


//////////////////
// WEBPACK FOOTER
// ./src/package.json
// module id = 1483
// module chunks = 0